import { batchGetDict } from "@/api/common";
import { API_RESULT_CODE, DictOption, DictType } from "@/config/types/common";
import { Button, CheckList, Form, Input, Popup, SafeArea, TextArea, Toast } from "antd-mobile";
import { CheckCircleFill } from "antd-mobile-icons";
import { useEffect, useState } from "react";

import "./AliasTextareaPopup.less";
interface AliasTextareaPopupPorps {
  visible: boolean;
  alias: DictType; // 字典项的名字
  name: string; // 原因的form的字段名
  title: string; // 弹窗的标题
  loading?: boolean; // 按钮的loading
  values?: any; // 额外的数据，在onOk()中会回传回去
  onClose: () => void;
  onOk: (values: any) => void;
}

/**
 * 通过读取字典项中的内容，将信息填充到文本框中
 */
const AliasTextareaPopup = ({
  visible,
  alias,
  name,
  title,
  values: initValues,
  onClose,
  onOk,
}: AliasTextareaPopupPorps) => {
  const REASON_MAX_LEN = 200;
  const [showReasonPop, setShowReasonPop] = useState(false); // 选择不通过原因的弹窗

  const [form] = Form.useForm();
  const [reasonForm] = Form.useForm();
  // const [options, setOptions] = useState<{ id: number; label: string; description: string }[]>([]);
  const [options, setOptions] = useState<DictOption[]>([]);

  // 获取「未通过」的原因列表
  const getOptions = async () => {
    // const alias = "moment_audit_deny";
    const { code, data, msg } = await batchGetDict([alias]);

    if (code === API_RESULT_CODE.SUCCESS) {
      setOptions(data?.[alias] || []);
    } else {
      Toast.show(msg || "获取不通过原因失败");
    }
  };

  /**
   * 解决移动端h5中的textarea无法滚动的问题
   * @see https://blog.csdn.net/qq_41219789/article/details/106218145
   */
  useEffect(() => {
    const listener = (event: any) => {
      if (event.target.tagName.toUpperCase() === "TEXTAREA") {
        event.stopPropagation();
      }
    };
    if (visible) {
      window.addEventListener("touchmove", listener, true);
      getOptions();

      return () => {
        window.removeEventListener("touchmove", listener);
        form.resetFields();
      };
    } else {
      window.removeEventListener("touchmove", listener);
    }
  }, [visible]);

  // 确认选择不通过的原因
  const handleSelectFailedReaons = () => {
    const reason = (reasonForm.getFieldValue("reason") || []).map((item: string) =>
      JSON.parse(item)
    );
    form.setFieldsValue({
      type: reason.map((item: any) => item.label).join("，"),
      [name]: reason
        .map((item: any) => item.description)
        .join("，")
        .substring(0, REASON_MAX_LEN),
    });
    setShowReasonPop(false);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onOk({ ...initValues, ...values });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Popup
        className="trend-audit-failed-popup"
        closeOnMaskClick
        visible={visible}
        onClose={onClose}
      >
        <div className="top">
          <Button fill="none" onClick={onClose}>
            取消
          </Button>
          <h3>{title}</h3>
        </div>
        <Form form={form}>
          <Form.Item name="type" label="问题类型" clickable onClick={() => setShowReasonPop(true)}>
            <Input placeholder="请选择问题类型" readOnly />
          </Form.Item>
          <Form.Item
            name={name}
            label="原因说明"
            rules={[{ required: true, message: "请补充原因说明" }]}
          >
            <TextArea maxLength={REASON_MAX_LEN} rows={4} showCount={true} />
          </Form.Item>
          <div className="submit-btn-container">
            <Button color="primary" type="submit" onClick={handleOk}>
              确定
            </Button>
          </div>
        </Form>
        <SafeArea position="bottom" />
      </Popup>
      <Popup
        className="trend-audit-failed-popup"
        closeOnMaskClick
        visible={showReasonPop}
        onClose={() => setShowReasonPop(false)}
      >
        <div className="top">
          <Button fill="none" onClick={() => setShowReasonPop(false)}>
            取消
          </Button>
          <h3>选择问题类型</h3>
        </div>
        <Form form={reasonForm}>
          <Form.Item name="reason">
            <CheckList className="fail-options-list" multiple activeIcon={<CheckCircleFill />}>
              {options.map((reason) => (
                <CheckList.Item key={reason.value} value={JSON.stringify(reason)}>
                  {reason.label}
                </CheckList.Item>
              ))}
            </CheckList>
          </Form.Item>
          <div className="submit-btn-container">
            <Button color="primary" type="submit" onClick={handleSelectFailedReaons}>
              确定
            </Button>
          </div>
        </Form>
        <SafeArea position="bottom" />
      </Popup>
    </>
  );
};
export default AliasTextareaPopup;
